import { VLB } from '@geeqdev/geeq_capnp_ts/generated/block.capnp';

import { Storage } from 'geeq_node_core/src/storage/interfaces';
import {
  ValidationLayerBlockWrapper,
} from 'geeq_node_core/src/capnp/wrappers/validation-layer-block';
import { GeeqNode } from 'geeq_node_core/src/actors/geeq-node';

export class VlbStorage implements Storage<ValidationLayerBlockWrapper, VLB> {
  private cacheSize = 10000;

  private wrappers = new Array<ValidationLayerBlockWrapper>();

  private readonly node: GeeqNode;

  constructor(node: GeeqNode) {
    this.node = node;
  }

  public async clearCache(): Promise<boolean> {
    this.wrappers = [];

    return true;
  }

  public async getCurrentBlock(): Promise<VLB> {
    return this.wrappers[0].getMessage();
  }

  public async getCurrentWrapper(): Promise<ValidationLayerBlockWrapper> {
    return this.wrappers[0];
  }

  public async isEmpty(): Promise<boolean> {
    return this.wrappers.length === 0;
  }

  public async save(wrapper: ValidationLayerBlockWrapper): Promise<boolean> {
    if (this.wrappers.length >= this.cacheSize) {
      this.wrappers.pop();
    }

    this.wrappers.unshift(wrapper);
    await this.node.addToLog('New VLB added to chain', wrapper);

    return true;
  }

  public setCacheSize(size: number): void {
    this.cacheSize = size;
  }
}
